import { UpgradeSource } from '../constants/upgradeSources';

// Router state cannot cross a tab boundary, so the source rides in the query.
export const upgradeLinkProps = (source: UpgradeSource) => ({
  to: `/upgrade?source=${encodeURIComponent(source)}`,
  target: '_blank' as const,
  rel: 'noopener noreferrer',
});
